const content = {
    reddit_data_upload: {
        en: {
            summary_no_video_html: '<p>This is the second part of the Reddit data task. Please upload your Reddit data file by following the instructions below:</p>',
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Open the <b>Reddit</b> app on your phone.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Tap <b>Messages</b> (the bell icon on the bottom right).</p>'
              },
              {
                step_type: 'numbered_step',
                number: '3',
                description_html: `<p>Inside Messages, tap to open the RedditDataRequest message.</p>`
              },
              {
                step_type: 'numbered_step',
                number: '4',
                description_html: `<p>Tap <b>Download Here</b></p>`
              },
              {
                step_type: 'numbered_step',
                number: '5',
                description_html: `<p>When you have done that, back in the MSR app, tap the <b>Upload</b> button and select your Reddit file from your Downloads folder.</p>`
              },
              {
                step_type: 'numbered_step',
                number: '6',
                description_html: `<p>Wait for the upload to complete and you're all done!</p>`
              }
            ],
            part_1_instructions_link: 'https://help.measureprotocol.com/en/support/solutions/articles/80001128764-reddit-data-file-reddit-instructions'
        }
    }
}

export const redditDataTypes = {
    reddit_data_upload: {
        data_type: 'reddit_data_upload',
        data_type_description: 'Reddit Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/reddit/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.reddit_data_upload,
        }
    },
} 